import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const StockAdjustmentForm = ({ 
    product = null, 
    onSubmit, 
    onCancel, 
    loading = false 
}) => {
    const { t } = useTranslation(['inventory', 'common']);
    const [formData, setFormData] = useState({
        quantity: 0,
        notes: '',
        reference_number: ''
    });

    useEffect(() => {
        // Reset form when product changes
        setFormData({
            quantity: 0,
            notes: '',
            reference_number: ''
        });
    }, [product]);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Ensure quantity is a valid number before submitting
        const submissionData = {
            ...formData,
            quantity: typeof formData.quantity === 'string' ? parseInt(formData.quantity) || 0 : formData.quantity
        };
        
        onSubmit(submissionData);
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleQuantityChange = (e) => {
        const inputValue = e.target.value;
        
        // Allow empty string, minus sign, and valid numbers (including negatives)
        if (inputValue === '' || inputValue === '-') {
            handleChange('quantity', inputValue);
        } else {
            const numValue = parseInt(inputValue);
            if (!isNaN(numValue)) {
                handleChange('quantity', numValue);
            }
        }
    };

    if (!product) {
        return null;
    }

    return (
        <form onSubmit={handleSubmit}>
            <div className="adjustment-info">
                <h4>{product.name} ({product.sku})</h4>
                <p>{t('inventory:currentStock')}: {product.quantity_in_stock}</p>
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:adjustment')} *</label>
                <input
                    type="number"
                    className="form-input"
                    value={formData.quantity}
                    onChange={handleQuantityChange}
                    required
                    placeholder={t('inventory:adjustmentPlaceholder')}
                />
                <small className="form-help">
                    {t('inventory:adjustmentHelp')}
                </small>
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:reference')}</label>
                <input
                    type="text"
                    className="form-input"
                    value={formData.reference_number}
                    onChange={(e) => handleChange('reference_number', e.target.value)}
                />
            </div>

            <div className="form-group">
                <label className="form-label">{t('inventory:notes')}</label>
                <textarea
                    className="form-input"
                    value={formData.notes}
                    onChange={(e) => handleChange('notes', e.target.value)}
                />
            </div>

            <div className="modal-footer">
                <button type="button" onClick={onCancel} className="btn btn-secondary">
                    {t('common:cancel')}
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? t('common:loading') : t('common:save')}
                </button>
            </div>
        </form>
    );
};

export default StockAdjustmentForm;